import { SFSGenderOptions } from 'util/helpers';
import {
  ApiPetProfileAvatarImageSourceEnum,
  ApiPetProfileStatusEnum,
  ApiPetProfileStatusReasonEnum,
} from '../api/generated-client/PetProfile-Service-A.v1/models';

export interface Medication {
  id: number;
  name: string;
}

export interface MedicationAllergy {
  id: number;
  name: string;
}

export interface Allergy {
  id: number;
  name: string;
}

export interface MedicalCondition {
  id: number;
  name: string;
}

export interface RidingStyle {
  id: number;
  name: string;
}

export interface PrimaryDiscipline {
  id: number;
  name: string;
}

export interface PetType {
  id: number;
  name: AnimalTypeNames;
  pharmacyEligible?: boolean;
  vetDietEligible?: boolean;
}

export interface PetAvatar {
  id: string | number;
  imageUrl: string;
  uploadImage?: any;
  caption?: string;
}

export interface PetAvatarOptions {
  avatars: Array<PetAvatar>;
}

export type AnimalTypeOptions = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8';

export type AnimalTypeNames =
  | 'dog'
  | 'cat'
  | 'fish'
  | 'bird'
  | 'small_pet'
  | 'reptile'
  | 'horse'
  | 'farm_animal';

export enum AnimalTypeId {
  dog = 1,
  cat = 2,
  fish = 3,
  bird = 4,
  smallPet = 5,
  reptile = 6,
  horse = 7,
  farmAnimal = 8,
}

export enum SterilizationOptions {
  unknown = 'UNKNOWN_STERILIZATION',
  yes = 'YES_STERILIZATION',
  no = 'NO_STERILIZATION',
}

export interface petProfileParams {
  petId: string;
}

export type PetSizeOptions = 'XS' | 'SM' | 'M' | 'L' | 'XL' | 'G' | 'UNKNOWN_SIZE';

export interface PetInterface {
  id: number;
  name: string;
  petType: PetType;
  petBreedId: number;
  petBreedName: string;
  petBreedSize: PetSizeOptions;
  secondaryBreedId?: number;
  secondaryBreedName: string;
  gender: SFSGenderOptions;
  lifestage: string;
  birthdayDate?: string;
  birthday?: number;
  adoptDate?: string;
  adoptionDate?: number;
  ageInMonths?: number;
  years?: string;
  months?: string;
  avatarId: number;
  avatarUrl: string;
  avatarSource?: ApiPetProfileAvatarImageSourceEnum;
  adopted: boolean;
  status?: ApiPetProfileStatusEnum;
  photoUrl?: string;
  sizeType: PetSizeOptions;
  weightLbs?: number;
  allergies: Array<Allergy>;
  medications: Array<Medication>;
  medicationAllergies: Array<MedicationAllergy>;
  medicalConditions: Array<MedicalCondition>;
  isSterilized?: SterilizationOptions;
  derivedGender?: string;
  petTypeId: AnimalTypeOptions;
  ownerName?: string;
  statusReason?: ApiPetProfileStatusReasonEnum;
  ridingStyles?: Array<RidingStyle>;
  primaryDisciplines?: Array<PrimaryDiscipline>;
}

export interface CreatePetCommentRequestSfs {
  profileId: number;
  comment: string;
}

export interface DeletePetProfileRequest {
  profileId: string;
  statusReason: 'OTHER';
}
